import React, {useEffect} from "react";
import "../styles/Cursor-style.css";

const Cursor = () => {
    useEffect(() => {
        const syncPointer = ({ x, y }) => {
            const rings = document.querySelectorAll('.ring');
            rings.forEach((ring) => {
                requestAnimationFrame(() => {
                    ring.style.setProperty('transform',`translateX(calc(${x}px - 1.25rem)) translateY(calc(${y}px - 1.25rem))`);
                });
            });
        };

        document.body.addEventListener('pointermove', syncPointer);

        return () => {
            document.body.removeEventListener('pointermove', syncPointer);
        };
    }, []);

return (
    <>
        <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
            integrity="sha512-1ycn6IcaQQ40/MKBW2W4Rhis/DbILU74C1vSrLJxCq57o941Ym01SwNsOMqvEBFlcgUa6xLiPY/NS5R+E6ztJQ=="
            crossOrigin="anonymous"
            referrerPolicy="no-referrer"
        />
        <div id="cursor" className="cursor">
            <div className="ring">
                <div></div>
            </div>
            <div className="ring">
                <div></div>
            </div>
        </div>
</>
    );
};

export default Cursor;